import React, {useEffect, useState} from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  Label,
  Button,
  InputGroup,
  InputGroupAddon,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import UnauthenticatedLayout from '../layouts/Unauthenticated/Unauthenticated';
import api from '../api';
import { useTranslation } from 'react-i18next';

const Registration = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    country: '',
    username: '',
    fullName: '',
    userEmail: '',
    password: '',
    confirmPassword: '',
  });

  const [errors, setErrors] = useState({});
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [useCompanyEmail, setUseCompanyEmail] = useState(true);

  const {t} = useTranslation()

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const validationErrors = {};
    if (!formData.name) validationErrors.name = t('registration.validation.nameRequired');
    if (!formData.email) validationErrors.email = t('registration.validation.emailRequired');
    if (!useCompanyEmail && !formData.userEmail) validationErrors.userEmail = t('registration.validation.userEmailRequired');
    else if (!isValidEmail(formData.email)) validationErrors.email = t('registration.validation.invalidEmail');
    // if (!formData.address) validationErrors.address = 'Address is required'; 
    // if (!formData.country) validationErrors.country = 'Country is required';
    if (!formData.username) validationErrors.username = t('registration.validation.usernameRequired');
    if (!formData.fullName) validationErrors.fullName = t('registration.validation.fullNameRequired');
    if (formData.password.length < 8 || formData.password.toLowerCase() === formData.password) {
      validationErrors.password = t('registration.validation.passwordWeak');
    }
    if (formData.password !== formData.confirmPassword) {
      validationErrors.confirmPassword = t('registration.validation.passwordsMismatch');
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const requestData = {
      name: formData.name,
      email: formData.email,
      address: formData.address,
      country: formData.country,
      user: {
        login: formData.username,
        name: formData.fullName,
        passwd: formData.password,
        email: useCompanyEmail ? formData.email : formData.userEmail,
      },
    };


    api
      .companyRegistration(requestData)
      .then(res => {
        if (res.active) {
          localStorage.setItem('user', JSON.stringify(res));
          window.location.href = '/admin/strategy';
        } else {
          navigate('/login');
        }
      })
      .catch(e => console.error('registration error ', e));
  };

  const isValidEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user && user.uid) {
      // Если пользователь активен, перенаправляем на страницу админки
      navigate('/admin/strategy')
    }
  }, [navigate])

  return (
    <UnauthenticatedLayout>
      <Container className='d-flex vh-100'>
        <Row className='m-auto align-self-center w-100'>
          <Col className='m-auto' md='6'>
            <Card>
              <CardBody>
                <h3 className='text-center mb-4'>{t('registration.title')}</h3>
                <form onSubmit={handleSubmit} noValidate>
                  <h4 className='text-center mb-4'>
                    {t('registration.companyInfoTitle')}
                    <span className='text-danger'>*</span>
                  </h4>

                  <FormGroup>
                    <Label for='name'>
                      {t('registration.companyName')}
                      <span className='text-danger'>*</span>
                    </Label>
                    <Input
                      type='text'
                      name='name'
                      id='name'
                      placeholder={t('registration.placeholders.companyName')}
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && <p className='text-danger'>{errors.name}</p>}
                  </FormGroup>

                  <FormGroup>
                    <Label for='email'>
                      {t('registration.email')}
                      <span className='text-danger'>*</span>
                    </Label>
                    <Input
                      type='email'
                      name='email'
                      id='email'
                      placeholder={t('registration.placeholders.email')}
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && <p className='text-danger'>{errors.email}</p>}
                  </FormGroup>

                  <FormGroup>
                    <Label for='address'>{t('registration.address')}</Label>
                    <Input
                      type='text'
                      name='address'
                      id='address'
                      placeholder={t('registration.placeholders.address')}
                      value={formData.address}
                      onChange={handleChange}
                    />
                    {errors.address && <p className='text-danger'>{errors.address}</p>}
                  </FormGroup>

                  <FormGroup>
                    <Label for='country'>{t('registration.country')}</Label>
                    <Input
                      type='text'
                      name='country'
                      id='country'
                      placeholder={t('registration.placeholders.country')}
                      value={formData.country}
                      onChange={handleChange}
                    />
                    {errors.country && <p className='text-danger'>{errors.country}</p>}
                  </FormGroup>

                  <h4 className='text-center mb-4'>
                    {t('registration.userInfoTitle')}
                    <span className='text-danger'>*</span>
                  </h4>

                  <FormGroup>
                    <Label for='fullName'>
                      {t('registration.fullName')}
                      <span className='text-danger'>*</span>
                    </Label>
                    <Input
                      type='text'
                      name='fullName'
                      id='fullName'
                      placeholder={t('registration.placeholders.fullName')}
                      value={formData.fullName}
                      onChange={handleChange}
                    />
                    {errors.fullName && <p className='text-danger'>{errors.fullName}</p>}
                  </FormGroup>

                  <FormGroup>
                    <Label for='userEmail'>{t('registration.userEmail')}</Label>
                    <Input
                      type='email'
                      name='userEmail'
                      id='userEmail'
                      placeholder={t('registration.placeholders.userEmail')}
                      value={formData.userEmail}
                      onChange={handleChange}
                      disabled={useCompanyEmail}
                    />
                    {errors.userEmail && <p className='text-danger'>{errors.userEmail}</p>}
                  </FormGroup>

                  <FormGroup className='custom-checkbox'>
                    <Label check>
                      <Input
                        type='checkbox'
                        aria-label='Use company email'
                        tabIndex='-1'
                        checked={useCompanyEmail}
                        onChange={e => setUseCompanyEmail(e.target.checked)}
                      />
                      {t('registration.useCompanyEmail')}
                    </Label>
                  </FormGroup>

                  <FormGroup>
                    <Label for='username'>
                      {t('registration.login')}
                      <span className='text-danger'>*</span>
                    </Label>
                    <Input
                      type='text'
                      name='username'
                      id='username'
                      placeholder={t('registration.placeholders.login')}
                      value={formData.username}
                      onChange={handleChange}
                    />
                    {errors.username && <p className='text-danger'>{errors.username}</p>}
                  </FormGroup>

                  <FormGroup>
                    <Label for='password'>
                      {t('registration.password')}
                      <span className='text-danger'>*</span>
                    </Label>
                    <InputGroup>
                      <Input
                        type={passwordVisible ? 'text' : 'password'}
                        name='password'
                        id='password'
                        placeholder={t('registration.placeholders.password')}
                        value={formData.password}
                        onChange={handleChange}
                      />
                      <InputGroupAddon addonType='append'>
                        <Button
                          color='light'
                          onClick={togglePasswordVisibility}
                          tabIndex='-1'
                          className='border-0 bg-transparent btn-sm h-100 m-0'>
                          <i className={`fa-solid fa-eye${passwordVisible ? '-slash' : ''}`} />
                        </Button>
                      </InputGroupAddon>
                    </InputGroup>
                    {errors.password && <p className='text-danger'>{errors.password}</p>}
                  </FormGroup>

                  <FormGroup>
                    <Label for='confirmPassword'>
                      {t('registration.confirmPassword')}
                      <span className='text-danger'>*</span>
                    </Label>
                    <InputGroup>
                      <Input
                        type={confirmPasswordVisible ? 'text' : 'password'}
                        name='confirmPassword'
                        id='confirmPassword'
                        placeholder={t('registration.placeholders.confirmPassword')}
                        value={formData.confirmPassword}
                        onChange={handleChange}
                      />
                      <InputGroupAddon addonType='append'>
                        <Button
                          color='light'
                          onClick={toggleConfirmPasswordVisibility}
                          tabIndex='-1'
                          className='border-0 bg-transparent btn-sm h-100 m-0'>
                          <i className={`fa-solid fa-eye${confirmPasswordVisible ? '-slash' : ''}`} />
                        </Button>
                      </InputGroupAddon>
                    </InputGroup>
                    {errors.confirmPassword && <p className='text-danger'>{errors.confirmPassword}</p>}
                  </FormGroup>

                  <Button type='submit' color='primary' className='w-100'>
                    {t('registration.title')}
                  </Button>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </UnauthenticatedLayout>
  );
};

export default Registration;
